import HeaderHero from "./HeaderHero";
import JotFormComponentPackage from "../../components/form/JotFormEmbedPackage";
import "./EnrollPage.scss";
import React from "react";

function EnrollPagePackage() {
	React.useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	return (
		<>
			<div>
				<HeaderHero
					title="CHOOSE YOUR PACKAGES"
					subtitle="Select your desired agency and package."
				/>
				<div className="enroll-page">
					<JotFormComponentPackage />
				</div>
			</div>
		</>
	);
}

export default EnrollPagePackage;
